var _defs, _rect, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89 37.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-1{opacity:0.4;}.cls-2{opacity:0.8;}.cls-4{fill:none;stroke:#fff;stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.12,
    width: 31.88,
    height: 23.91,
    rx: 2.38
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 13.28,
    width: 31.88,
    height: 23.91,
    rx: 2.38
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M343.62,139a1.38,1.38,0,0,1,1.38,1.38v19.16a1.38,1.38,0,0,1-1.38,1.37H316.49a1.38,1.38,0,0,1-1.37-1.37V140.38a1.38,1.38,0,0,1,1.37-1.38h27.13m0-1H316.49a2.37,2.37,0,0,0-2.37,2.38v19.16a2.37,2.37,0,0,0,2.37,2.37h27.13a2.37,2.37,0,0,0,2.38-2.37V140.38a2.37,2.37,0,0,0-2.38-2.38Z",
    transform: "translate(-257 -138)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M286.51,152.28a1.38,1.38,0,0,1,1.37,1.38v19.16a1.37,1.37,0,0,1-1.37,1.37H259.38a1.37,1.37,0,0,1-1.38-1.37V153.66a1.38,1.38,0,0,1,1.38-1.38h27.13m0-1H259.38a2.38,2.38,0,0,0-2.38,2.38v19.16a2.37,2.37,0,0,0,2.38,2.37h27.13a2.37,2.37,0,0,0,2.37-2.37V153.66a2.38,2.38,0,0,0-2.37-2.38Z",
    transform: "translate(-257 -138)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "30.55 27.23 29.22 27.23 29.22 35.2 30.55 35.2 30.55 27.23 30.55 27.23"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "30.55 15.94 29.22 15.94 29.22 23.91 30.55 23.91 30.55 15.94 30.55 15.94"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "87.67 13.95 86.34 13.95 86.34 21.92 87.67 21.92 87.67 13.95 87.67 13.95"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "87.67 2.66 86.34 2.66 86.34 10.63 87.67 10.63 87.67 2.66 87.67 2.66"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 31.22,
    y1: 28.56,
    x2: 44.5,
    y2: 28.56
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 43.84,
    y1: 7.31,
    x2: 57.12,
    y2: 7.31
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 44.5,
    y1: 7.31,
    x2: 44.5,
    y2: 28.56
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnected);
export default __webpack_public_path__ + "static/media/connected.2dcf123c970d593aa0d7bfb16157a62e.svg";
export { ForwardRef as ReactComponent };